"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var transformStaticPage = function transformStaticPage(_ref) {
  var attributes = _ref.attributes;
  return {
    title: attributes.title,
    content: attributes.content
  };
};

var _default = transformStaticPage;
exports.default = _default;